/*
  gp-cart-fx.js — sitewide add-to-cart effect + WebAudio chime (SPEC-ROUND2 §E).

  How it hooks the theme (Carbon):
  - The theme's own AJAX adds (product-form custom element in theme.js,
    rocket-launch's fetch) all go through window.fetch to routes.cart_add_url.
    We wrap window.fetch once and fire the effect on any successful response
    to a /cart/add request. The native success path (publish('cart-update'),
    cart-drawer.renderContents) is untouched — we only layer the effect on top.
  - gp-shop cards use a plain full-page <form method="post" action="/cart/add">.
    For those (and ONLY those — forms not inside a <product-form> element) we
    intercept the submit, POST to /cart/add.js with the same `sections` payload
    rocket-launch uses, and hand the parsed response to the theme's own
    cart-drawer.renderContents() so drawer + cart-icon-bubble refresh exactly
    like a native add. If the drawer is missing we fall back to /cart like the
    theme does.
*/
(function () {
  'use strict';

  var TRIGGER_SELECTOR = [
    'product-form [type="submit"]',
    'form[action*="/cart/add"] [type="submit"]',
    '[name="add"]',
    '[data-rl-add]',
    '.quick-add__submit',
  ].join(', ');

  var lastTrigger = null;
  var lastTriggerAt = 0;
  var lastChimeAt = 0;
  var audioCtx = null;

  var reducedMotion = false;
  try {
    reducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    /* noop */
  }

  /* ------------------------------------------------------------------ *
   * Remember which button started the add (for the flight origin).
   * ------------------------------------------------------------------ */
  document.addEventListener(
    'click',
    function (evt) {
      var t = evt.target && evt.target.closest
        ? evt.target.closest(TRIGGER_SELECTOR)
        : null;
      if (t) {
        lastTrigger = t;
        lastTriggerAt = Date.now();
      }
    },
    true
  );

  /* ------------------------------------------------------------------ *
   * Universal hook: wrap window.fetch, watch for successful /cart/add.
   * ------------------------------------------------------------------ */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;

      var result = nativeFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        result.then(function (response) {
          if (response && response.ok) onAddSuccess();
        }).catch(function () { /* network error: no effect */ });
      }
      return result;
    };
  }

  /* ------------------------------------------------------------------ *
   * gp-shop plain forms: AJAX them through the theme's own drawer path.
   * ------------------------------------------------------------------ */
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      if (form.closest('product-form')) return; // theme.js already AJAXes these
      if (form.hasAttribute('data-gp-fx-busy')) { evt.preventDefault(); return; }

      evt.preventDefault();
      form.setAttribute('data-gp-fx-busy', '');
      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-disabled', 'true');

      var fd = new FormData(form);
      var id = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      var addUrl =
        (window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add') + '.js';

      var done = function () {
        form.removeAttribute('data-gp-fx-busy');
        if (button) button.removeAttribute('aria-disabled');
      };

      if (!id) { done(); return; }

      fetch(addUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          items: [{id: id, quantity: qty}],
          sections: ['cart-drawer', 'cart-icon-bubble', 'product-free-shipping'],
        }),
      })
        .then(function (r) {
          return r.json().then(function (parsed) {
            return {ok: r.ok, parsed: parsed};
          });
        })
        .then(function (res) {
          done();
          if (!res.ok) {
            console.warn('[gp-cart-fx] add failed', res.parsed);
            return;
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.renderContents && res.parsed && res.parsed.sections) {
            drawer.renderContents(res.parsed);
          } else {
            // No drawer on page: give the effect a beat, then confirm on /cart.
            setTimeout(function () {
              window.location.href =
                (window.routes && window.routes.cart_url) || '/cart';
            }, 900);
          }
        })
        .catch(function (e) {
          console.warn('[gp-cart-fx] add error', e);
          done();
        });
    },
    true
  );

  /* ------------------------------------------------------------------ *
   * Effect: flight + icon pulse + badge bump + chime.
   * ------------------------------------------------------------------ */
  function onAddSuccess() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!reducedMotion) flyToCart(cartIcon);
    pulseAndBump(cartIcon);
    chime();
  }

  function findSourceImage() {
    if (!lastTrigger || Date.now() - lastTriggerAt > 4000) return null;
    if (!document.body.contains(lastTrigger)) return null;
    var scopes = [
      '.gp-shop__card',
      '.card-wrapper',
      '.card',
      'product-info',
      'product-form',
      'rocket-launch',
      'form',
      'section',
    ];
    for (var i = 0; i < scopes.length; i++) {
      var scope = lastTrigger.closest(scopes[i]);
      if (!scope) continue;
      var imgs = scope.querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        var r = imgs[j].getBoundingClientRect();
        if (r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < window.innerHeight) {
          return imgs[j];
        }
      }
    }
    return null;
  }

  function goldBagSvg() {
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5 8h14l-1.2 12.2a1.8 1.8 0 0 1-1.8 1.6H8a1.8 1.8 0 0 1-1.8-1.6L5 8Z" ' +
      'fill="#c9a24b" stroke="#8a6d2f" stroke-width="1.2"/>' +
      '<path d="M9 10V6.5a3 3 0 0 1 6 0V10" stroke="#8a6d2f" stroke-width="1.6" ' +
      'stroke-linecap="round" fill="none"/></svg>';
    return wrap.firstChild;
  }

  function flyToCart(cartIcon) {
    if (!cartIcon || typeof Element.prototype.animate !== 'function') return;

    var sourceImg = findSourceImage();
    var startRect;
    var visual;
    if (sourceImg) {
      startRect = sourceImg.getBoundingClientRect();
      visual = document.createElement('img');
      visual.src = sourceImg.currentSrc || sourceImg.src;
      visual.alt = '';
    } else if (lastTrigger && Date.now() - lastTriggerAt < 4000 &&
               document.body.contains(lastTrigger)) {
      startRect = lastTrigger.getBoundingClientRect();
      visual = goldBagSvg();
    } else {
      return; // nowhere sensible to start from — pulse + chime carry it
    }

    var iconRect = cartIcon.getBoundingClientRect();
    var size = Math.min(140, Math.max(56, Math.min(startRect.width, startRect.height)));
    var startX = startRect.left + startRect.width / 2 - size / 2;
    var startY = startRect.top + startRect.height / 2 - size / 2;
    var endX = iconRect.left + iconRect.width / 2 - size / 2;
    var endY = iconRect.top + iconRect.height / 2 - size / 2;

    var outer = document.createElement('div');
    outer.className = 'gp-fx-fly';
    outer.setAttribute('aria-hidden', 'true');
    var inner = document.createElement('div');
    inner.className = 'gp-fx-fly__inner';
    inner.style.width = size + 'px';
    inner.style.height = size + 'px';
    inner.appendChild(visual);
    outer.appendChild(inner);
    outer.style.transform = 'translate(' + startX + 'px,' + startY + 'px)';
    document.body.appendChild(outer);

    // Curved path: X eases out while Y eases in — a natural arc toward the
    // header — while the inner element shrinks to 0.15 and fades.
    var duration = 700;
    outer.animate(
      [
        {transform: 'translate(' + startX + 'px,' + startY + 'px)'},
        {transform: 'translate(' + endX + 'px,' + startY + 'px)'},
      ],
      {duration: duration, easing: 'cubic-bezier(0.2, 0.6, 0.4, 1)', fill: 'forwards'}
    );
    var flight = inner.animate(
      [
        {transform: 'translateY(0) scale(1)', opacity: 1},
        {transform: 'translateY(' + (endY - startY) + 'px) scale(0.15)', opacity: 0.2},
      ],
      {duration: duration, easing: 'cubic-bezier(0.5, 0, 0.75, 1)', fill: 'forwards'}
    );
    flight.onfinish = function () {
      if (outer.parentNode) outer.parentNode.removeChild(outer);
    };
    // Safety net if onfinish never fires.
    setTimeout(function () {
      if (outer.parentNode) outer.parentNode.removeChild(outer);
    }, duration + 400);
  }

  function pulseAndBump(cartIcon) {
    if (!cartIcon) return;
    var delay = reducedMotion ? 0 : 620; // pulse as the flight lands
    setTimeout(function () {
      cartIcon.classList.remove('gp-fx-pulse');
      // Force restart of the animation on rapid successive adds.
      void cartIcon.offsetWidth;
      cartIcon.classList.add('gp-fx-pulse');
      setTimeout(function () { cartIcon.classList.remove('gp-fx-pulse'); }, 700);
      updateBadge(cartIcon);
    }, delay);
  }

  function updateBadge(cartIcon) {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: {Accept: 'application/json'},
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        var bubble = cartIcon.querySelector('.cart-count-bubble');
        if (!bubble) {
          // Cart was empty: the section render may still be in flight — build
          // the same markup the header renders so the count shows immediately.
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          var host = cartIcon.querySelector('.header__menu-item') || cartIcon;
          host.appendChild(bubble);
        }
        var num = bubble.querySelector('span[aria-hidden]');
        if (num && cart.item_count < 100) num.textContent = cart.item_count;
        bubble.classList.remove('gp-fx-bump');
        void bubble.offsetWidth;
        bubble.classList.add('gp-fx-bump');
        setTimeout(function () { bubble.classList.remove('gp-fx-bump'); }, 600);
      })
      .catch(function () { /* section render will catch up */ });
  }

  /* ------------------------------------------------------------------ *
   * Chime: two soft triangle notes (E6 then B6), WebAudio only.
   * ------------------------------------------------------------------ */
  function chime() {
    // The add click IS the user gesture; without any activation, stay silent.
    if (!navigator.userActivation || !navigator.userActivation.hasBeenActive) return;
    var now = Date.now();
    if (now - lastChimeAt < 700) return; // no sound spam
    lastChimeAt = now;

    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      if (!audioCtx) audioCtx = new AC();
      if (audioCtx.state === 'suspended') audioCtx.resume();
      note(1318.51, 0, 0.16);    // E6
      note(1975.53, 0.13, 0.16); // B6
    } catch (e) {
      /* audio blocked: effect stays visual */
    }
  }

  function note(freq, delay, dur) {
    var t0 = audioCtx.currentTime + delay;
    var osc = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.linearRampToValueAtTime(0.1, t0 + 0.02); // gentle attack, <=0.12
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur); // gentle decay
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(t0);
    osc.stop(t0 + dur + 0.05);
  }
})();
